export const content = {
  title: "About ANC Academy", 
  subtitle: "Welcome to the best online flight training school you can find for flight simulator.",
  image: {
    url: "./assets/da62Hangar.jpg",
    alt: "MSFS Da62 in Hangar",
  }
}